/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectDomainAuditRowData
 */
export interface ProjectDomainAuditRowData {
    /**
     * 
     * @type {string}
     * @memberof ProjectDomainAuditRowData
     */
    source?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDomainAuditRowData
     */
    flow?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectDomainAuditRowData
     */
    entityType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectDomainAuditRowData
     */
    remoteEntityId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectDomainAuditRowData
     */
    urlField?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectDomainAuditRowData
     */
    sourceUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectDomainAuditRowData
     */
    reason?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectDomainAuditRowData
     */
    advertisingCategory?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectDomainAuditRowData
     */
    advertisingDestinationStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectDomainAuditRowData
     */
    advertisingClassificationReason?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectDomainAuditRowData
     */
    decision?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDomainAuditRowData
     */
    hostName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectDomainAuditRowData
     */
    selectedDomainHostName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectDomainAuditRowData
     */
    occurrenceCount?: number;
    /**
     * 
     * @type {Date}
     * @memberof ProjectDomainAuditRowData
     */
    firstSeenAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProjectDomainAuditRowData
     */
    lastSeenAt?: Date;
}

/**
 * Check if a given object implements the ProjectDomainAuditRowData interface.
 */
export function instanceOfProjectDomainAuditRowData(value: object): value is ProjectDomainAuditRowData {
    return true;
}

export function ProjectDomainAuditRowDataFromJSON(json: any): ProjectDomainAuditRowData {
    return ProjectDomainAuditRowDataFromJSONTyped(json, false);
}

export function ProjectDomainAuditRowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDomainAuditRowData {
    if (json == null) {
        return json;
    }
    return {
        
        'source': json['source'] == null ? undefined : json['source'],
        'flow': json['flow'] === undefined ? undefined : json['flow'] === null ? null : json['flow'],
        'entityType': json['entityType'] === undefined ? undefined : json['entityType'] === null ? null : json['entityType'],
        'remoteEntityId': json['remoteEntityId'] === undefined ? undefined : json['remoteEntityId'] === null ? null : json['remoteEntityId'],
        'urlField': json['urlField'] === undefined ? undefined : json['urlField'] === null ? null : json['urlField'],
        'sourceUrl': json['sourceUrl'] === undefined ? undefined : json['sourceUrl'] === null ? null : json['sourceUrl'],
        'reason': json['reason'] === undefined ? undefined : json['reason'] === null ? null : json['reason'],
        'advertisingCategory': json['advertisingCategory'] === undefined ? undefined : json['advertisingCategory'] === null ? null : json['advertisingCategory'],
        'advertisingDestinationStatus': json['advertisingDestinationStatus'] === undefined ? undefined : json['advertisingDestinationStatus'] === null ? null : json['advertisingDestinationStatus'],
        'advertisingClassificationReason': json['advertisingClassificationReason'] === undefined ? undefined : json['advertisingClassificationReason'] === null ? null : json['advertisingClassificationReason'],
        'decision': json['decision'] == null ? undefined : json['decision'],
        'hostName': json['hostName'] === undefined ? undefined : json['hostName'] === null ? null : json['hostName'],
        'selectedDomainHostName': json['selectedDomainHostName'] === undefined ? undefined : json['selectedDomainHostName'] === null ? null : json['selectedDomainHostName'],
        'occurrenceCount': json['occurrenceCount'] == null ? undefined : json['occurrenceCount'],
        'firstSeenAt': json['firstSeenAt'] == null ? undefined : (new Date(json['firstSeenAt'])),
        'lastSeenAt': json['lastSeenAt'] == null ? undefined : (new Date(json['lastSeenAt'])),
    };
}

export function ProjectDomainAuditRowDataToJSON(json: any): ProjectDomainAuditRowData {
    return ProjectDomainAuditRowDataToJSONTyped(json, false);
}

export function ProjectDomainAuditRowDataToJSONTyped(value?: ProjectDomainAuditRowData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'source': value['source'],
        'flow': value['flow'],
        'entityType': value['entityType'],
        'remoteEntityId': value['remoteEntityId'],
        'urlField': value['urlField'],
        'sourceUrl': value['sourceUrl'],
        'reason': value['reason'],
        'advertisingCategory': value['advertisingCategory'],
        'advertisingDestinationStatus': value['advertisingDestinationStatus'],
        'advertisingClassificationReason': value['advertisingClassificationReason'],
        'decision': value['decision'],
        'hostName': value['hostName'],
        'selectedDomainHostName': value['selectedDomainHostName'],
        'occurrenceCount': value['occurrenceCount'],
        'firstSeenAt': value['firstSeenAt'] == null ? value['firstSeenAt'] : value['firstSeenAt'].toISOString(),
        'lastSeenAt': value['lastSeenAt'] == null ? value['lastSeenAt'] : value['lastSeenAt'].toISOString(),
    };
}

